import { FormattedMessage, useIntl } from 'react-intl'
import Head from 'next/head'

import { Heading, ContentStack } from '@gaia-family/ds'

import { Screen } from '../../components/Layout'

import { SignInFormManager } from '@components/forms/auth/SignIn'

const SignIn = () => {
  const { formatMessage } = useIntl()
  return (
    <Screen>
      <Head>
        <title>
          {formatMessage({
            defaultMessage: 'Sign In - Gaia',
          })}
        </title>
      </Head>
      <ContentStack
        flex={1}
        direction="column"
        width="full"
        maxWidth="prose"
        px="md"
        py="md"
        minWidth={['auto', 'prose']}
      >
        <Heading>
          <FormattedMessage defaultMessage="Sign In" />
        </Heading>
        <SignInFormManager />
      </ContentStack>
    </Screen>
  )
}

export default SignIn
